module.exports = __webpack_public_path__ + "static/media/kittymapper.c8217380.png";